import ls from '../../utils/localStorage.js';
import { getCases,getCasesDetail } from '../../api/api';

const state = {
  cases_list: '',
  cases_detail: ''
}

const mutations = {
    UPDATE_CASES_LIST(state,payload) {
        state.cases_list = JSON.parse(payload);
    },
	UPDATE_CASES_DETAIL(state,payload) {
	    state.cases_detail = JSON.parse(payload);
	}
}

const getters = {

}

const actions = {

    // 获取门店列表
    requestCases(store,item) {
        getCases(item.city).then( data => {
            item.thit.loading = true;
            store.commit('UPDATE_CASES_LIST',JSON.stringify(data));
        }).catch(error => {
            
        })
    },

	// 获取门店详情
	requestCasesDetail(store,item) {
	    getCasesDetail(item.id).then( data => {
	        store.commit('UPDATE_CASES_DETAIL',JSON.stringify(data));
	    }).catch(error => {
	        
	    })
	}

}

export default {
    state,
    mutations,
    getters,
    actions
}
